"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedList = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VirtualizedList = /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(function (_ref, externalRef) {
  var _ref$componentId = _ref.componentId,
      componentId = _ref$componentId === void 0 ? 'StencilVirtualizedList' : _ref$componentId,
      items = _ref.items,
      itemHeight = _ref.itemHeight,
      visibleItems = _ref.visibleItems,
      renderListItem = _ref.renderListItem,
      selectedIndex = _ref.selectedIndex,
      highlightedIndex = _ref.highlightedIndex,
      hasHeader = _ref.hasHeader,
      hasFooter = _ref.hasFooter,
      hasOptionGroups = _ref.hasOptionGroups;
  var rootRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      start = _useState2[0],
      setStart = _useState2[1]; // This object contains all params that is using to calculate virtualzed list.
  // To keep good performance useRef is used instead of useState


  var paramsObject = {
    start: start,
    highlightedIndex: highlightedIndex,
    itemHeight: itemHeight,
    visibleItems: visibleItems,
    itemsLength: items.length
  };
  var paramsRef = (0, _react.useRef)(paramsObject);
  paramsRef.current = paramsObject;
  var scrollingParamsRef = (0, _react.useRef)({
    isScrolling: false,
    timer: undefined
  });
  var groupsBefore = 0;
  var groupIndexes = items.map(function (item) {
    if ((0, _typeof2.default)(item) === 'object' && item.type === _constants.GROUP) {
      groupsBefore++;
    }

    return groupsBefore;
  }); // Scroll to the selected item on initial render

  (0, _react.useEffect)(function () {
    if (selectedIndex > -1 && rootRef.current) {
      setStart(selectedIndex);
      rootRef.current.scrollTop = selectedIndex * itemHeight;
    } else {
      setStart(0);
    }
  }, [itemHeight, selectedIndex]); // Following highlighted option and scrolling to it

  (0, _react.useEffect)(function () {
    var handler = function handler(e) {
      var _paramsRef$current = paramsRef.current,
          highlightedIndex = _paramsRef$current.highlightedIndex,
          itemHeight = _paramsRef$current.itemHeight,
          start = _paramsRef$current.start,
          visibleItems = _paramsRef$current.visibleItems,
          itemsLength = _paramsRef$current.itemsLength;
      if (highlightedIndex === -1 || !rootRef.current) return; // Scrolling list on Page up/down keys

      if (e.keyCode === _utils.EventKeyCodes.PAGE_UP) {
        rootRef.current.scrollTop = rootRef.current.scrollTop - visibleItems * itemHeight;
        return;
      } else if (e.keyCode === _utils.EventKeyCodes.PAGE_DOWN) {
        rootRef.current.scrollTop = rootRef.current.scrollTop + visibleItems * itemHeight;
        return;
      }

      var groupIndexNumber = hasOptionGroups ? groupIndexes[highlightedIndex] : 0;
      var isOutOfViewport = highlightedIndex + groupIndexNumber >= visibleItems - 1 || highlightedIndex + groupIndexNumber < itemsLength - visibleItems - 1;

      if (highlightedIndex + groupIndexNumber >= start + visibleItems - 1) {
        if (!isOutOfViewport) {
          setStart(highlightedIndex);
        }

        rootRef.current.scrollTop = (highlightedIndex + groupIndexNumber - visibleItems + 2) * itemHeight;
      } else if (highlightedIndex + groupIndexNumber <= start) {
        if (!isOutOfViewport) {
          setStart(highlightedIndex);
        }

        rootRef.current.scrollTop = (highlightedIndex + groupIndexNumber - 1) * itemHeight;
      }
    };

    window.addEventListener('keydown', handler);
    return function () {
      window.removeEventListener('keydown', handler);

      if (scrollingParamsRef.current && scrollingParamsRef.current.timer) {
        // After unmounting timer will not clear callback from the stack.
        // Clearing it after umount manually.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearTimeout(scrollingParamsRef.current.timer);
      }
    };
  }, [groupIndexes, hasOptionGroups]);

  var mouseMoveCaptureHandler = function mouseMoveCaptureHandler(e) {
    if (scrollingParamsRef.current && scrollingParamsRef.current.isScrolling) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var scrollingHandler = function scrollingHandler(e) {
    if (scrollingParamsRef.current && scrollingParamsRef.current.timer) clearTimeout(scrollingParamsRef.current.timer);
    if (!e.currentTarget) return;
    setStart(Math.min(visibleItems >= items.length ? items.length - 1 : items.length - visibleItems - 1, Math.floor((e.currentTarget.scrollTop < 0 ? 0 : e.currentTarget.scrollTop) / itemHeight)));

    if (scrollingParamsRef.current) {
      scrollingParamsRef.current.isScrolling = true;
      scrollingParamsRef.current.timer = setTimeout(function () {
        return scrollingParamsRef.current.isScrolling = false;
      }, 300);
    }
  };

  var hasHeaderAndFooter = Number(hasHeader) + Number(hasFooter);
  var placeholderTopHeight = visibleItems >= items.length + hasHeaderAndFooter ? (items.length - 1 + hasHeaderAndFooter) * itemHeight : itemHeight * visibleItems + 1;
  var placeholderBottomHeight = Math.max(0, itemHeight * (items.length - (start + visibleItems + 1 + Number(hasFooter))));
  var optionGroupNameIndex = -1;
  var visibleItemsList = items.slice(start, start + visibleItems + 1).map(function (item, itemIndex) {
    if ((0, _typeof2.default)(item) === 'object' && item.type === _constants.GROUP) {
      optionGroupNameIndex = start + itemIndex;
      return (0, _core.jsx)(_helperComponents.OptionGroupName, {
        key: optionGroupNameIndex,
        role: "group",
        "aria-hidden": "true",
        id: "".concat(componentId, "-option-group-").concat(start + itemIndex),
        "aria-label": _constants.A11Y_GROUP_PREFIX + item.name
      }, (0, _core.jsx)("span", {
        hidden: true
      }, _constants.A11Y_GROUP_PREFIX), item.name);
    }

    var renderedItem = renderListItem(item, start + itemIndex - groupIndexes[start + itemIndex], optionGroupNameIndex);
    return renderedItem;
  });
  return (0, _core.jsx)("div", {
    ref: (0, _utils.mergeRefs)(externalRef, rootRef),
    style: {
      height: placeholderTopHeight,
      overflow: 'auto',
      position: 'relative'
    },
    onMouseMoveCapture: mouseMoveCaptureHandler,
    onScroll: scrollingHandler
  }, (0, _core.jsx)("div", {
    "data-test-id": "StencilVirtualizedPlaceholderTop",
    style: {
      height: itemHeight * start
    }
  }), (0, _core.jsx)("div", {
    "data-test-id": "StencilVirtualizedList"
  }, visibleItemsList), (0, _core.jsx)("div", {
    "data-test-id": "StencilVirtualizedPlaceholderBottom",
    style: {
      height: placeholderBottomHeight
    }
  }));
}));

exports.VirtualizedList = VirtualizedList;